const letElementTrueToShow = (setIsVerified,isVerified) =>{
  setIsVerified(isVerified = true);
}

export {letElementTrueToShow};